import type { ReactNode } from "react";

/** The site's work-history copy — Cloudflare only, VERBATIM from AJ's LinkedIn
 *  (lowercase and all). Deliberately separate from lib/resume.tsx: the resume keeps
 *  its own wording. Edit word for word, here only. */

export type LinkedInRole = {
  title: string;
  dates: string;
  duration: string;
  place: string;
  bullets: ReactNode[];
};

export const CLOUDFLARE_ROLES: LinkedInRole[] = [
  {
    title: "senior product manager - sase user experience and growth + swg & firewall",
    dates: "Oct 2024 - Present",
    duration: "2 yrs",
    place: "Austin, Texas, United States",
    bullets: [
      "took knowledge from 5+ years building gtm for our sase and zero trust products, used to improve customer experience across entire platform",
      "grew self serve revenue 200% and adoption over 100% after two years of flat growth in both",
      "now additionally own strategy and execution for secure web gateway, L4 firewall, DNS filtering, and more",
      "releasing first strategic integration between cloudflare developer platform (workers) and cloudflare one (sase)",
    ],
  },
  {
    title: "principal - sase gtm",
    dates: "Oct 2023 - Oct 2024",
    duration: "1 yr 1 mo",
    place: "Austin, Texas, United States · Hybrid",
    bullets: [
      "reported to global vp of sase sales",
      "50% of time working with our absolute top tier of global sase customers",
      "other 50% spent leading cross-functional projects to improve sase products in the market, customer experience, and sales efficacy and efficiency",
      <>
        authored thought leadership blogs and cornerstone public{" "}
        <a
          href="https://developers.cloudflare.com/cloudflare-one/implementation-guides/"
          target="_blank"
          rel="noopener"
        >
          implementation guides
        </a>
      </>,
    ],
  },
  {
    title: "zero trust and sase sales",
    dates: "Oct 2021 - Oct 2023",
    duration: "2 yrs 1 mo",
    place: "Austin, Texas Metropolitan Area",
    bullets: [
      "worked with over 3,500 customers over four years (loved almost every one)",
      "grew sase/zt business 25x",
      "core sales and deployment sme for cloudflare’s first three $1M+ sase deals",
      "built internal and external programs in sales strategy, enablement, operations, customer deployment",
      "built repeatable models for technical sales success",
      "defined SASE gtm strategy and executed programs to serve more customers, better, and faster",
    ],
  },
  {
    title: "stage zero gtm - zero trust and sase",
    dates: "Jun 2019 - Oct 2021",
    duration: "2 yrs 5 mos",
    place: "Austin, Texas Metropolitan Area",
    bullets: [
      "first gtm hire for sase (just barely remote access at the time)",
      "global sales and technical sales SME for ztna, swg, casb, etc.",
      "built out all initial sales programs, tight, constant collaboration with product and marketing",
      "1,500+ customer engagements in first 18 months",
    ],
  },
];
